import React, { useState, useEffect, useRef } from 'react';
import { useDealership } from '../../contexts/DealershipContext';
import './ChooseDealershipModal.css';

const ChooseDealershipModal = ({ onClose }) => {
  const { dealerships, loading, setActiveDealership } = useDealership();
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredDealerships, setFilteredDealerships] = useState([]);
  const modalRef = useRef(null);

  // Filter dealerships based on search term
  useEffect(() => {
    if (!dealerships) return;

    if (searchTerm.trim() === '') {
      setFilteredDealerships(dealerships);
    } else {
      const filtered = dealerships.filter(dealer => 
        dealer.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        dealer.bac?.toString().includes(searchTerm) ||
        dealer.city?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        dealer.state?.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredDealerships(filtered);
    }
  }, [searchTerm, dealerships]);

  // Handle click outside to close the modal
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onClose]);

  // Handle selecting a dealership
  const handleSelectDealership = async (dealership) => {
    try {
      await setActiveDealership(dealership);
      onClose();
    } catch (error) {
      //failed to select dealership
    }
  };

  return (
    <div className="choose-dealership-modal-backdrop">
      <div className="choose-dealership-modal" ref={modalRef}>
        <div className="choose-dealership-header">
          <h2>Choose Dealership</h2>
          <button className="close-button" onClick={onClose}>×</button>
        </div>

        <div className="dealership-search-container">
          <input
            type="text"
            className="dealership-search-input"
            placeholder="Search dealerships by name, BAC, city, or state..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          {searchTerm && (
            <button 
              className="clear-search-button"
              onClick={() => setSearchTerm('')}
            >
              ×
            </button>
          )}
        </div>

        <div className="dealership-list-container">
          {loading ? (
            <div className="dealership-loading">Loading dealerships...</div>
          ) : filteredDealerships.length > 0 ? (
            <div className="dealership-list">
              {filteredDealerships.map((dealership) => (
                <div
                  key={dealership.bac || dealership.id}
                  className="dealership-item"
                  onClick={() => handleSelectDealership(dealership)}
                >
                  <div className="dealership-info">
                    <h3 className="dealership-name">{dealership.name}</h3>
                    <div className="dealership-details">
                      <span className="dealership-bac">BAC: {dealership.bac}</span>
                      <span className="dealership-location">{dealership.city}, {dealership.state}</span>
                    </div>
                  </div>
                  <button className="select-dealership-button">Select</button>
                </div>
              ))}
            </div>
          ) : (
            <div className="no-dealerships-found">
              {searchTerm ? 'No dealerships match your search' : 'No dealerships available'}
            </div>
          )}
        </div>

        <div className="modal-footer">
          <button className="cancel-button" onClick={onClose}>Cancel</button>
        </div>
      </div>
    </div>
  );
};

export default ChooseDealershipModal;
